import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { PostProjectStatusModel } from "../../models/PostProjectStatusModel";
import ProjectStatusService from "../../services/ProjectStatusService";
import ProjectStatusSlice from "../slices/ProjectStatusSlice";
import { RootState } from "../store";
import { GetProjectStatusModel } from "../../models/ProjectStatusModel";

export const ProjectStatusActions = ProjectStatusSlice.actions;

export const postParticularProjectStatus = (
  projectStatus: PostProjectStatusModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async () => {
    await ProjectStatusService.postParticularProjectStatus(projectStatus);
  };
};

export const getProjectStatusAdmin = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: GetProjectStatusModel[] = await ProjectStatusService.getProjectStatusAdmin()
    dispatch(ProjectStatusActions.getProjectStatusAdmin(response))
  }
}